module.exports = __webpack_public_path__ + "packs/media/images/palestraYoga-d23244034dcab153c4757ed09ce8e6d4.jpg";